import React from "react";

import { Trans } from "app/utils";

const LinkedinReactionText = ({ reaction }) => {
  switch (reaction?.reactionType) {
    case "LIKE":
      return <span className="Linkedin-Reaction__Label" style={{ color: "rgb(10, 102, 194)" }}><Trans>Like</Trans></span>;
    case "PRAISE":
      return <span className="Linkedin-Reaction__Label" style={{ color: "rgb(68, 113, 46)" }}><Trans>Celebrate</Trans></span>;
    case "MAYBE":
      return <span className="Linkedin-Reaction__Label" style={{ color: "rgb(113, 94, 134)" }}><Trans>Curious</Trans></span>;
    case "EMPATHY":
      return <span className="Linkedin-Reaction__Label" style={{ color: "rgb(178, 64, 32)" }}><Trans>Love</Trans></span>;
    case "INTEREST":
      return <span className="Linkedin-Reaction__Label" style={{ color: "rgb(145, 89, 7)" }}><Trans>Insightful</Trans></span>;
    case "APPRECIATION":
      return <span className="Linkedin-Reaction__Label" style={{ color: "rgb(128, 89, 126)" }}><Trans>Support</Trans></span>;
    case "ENTERTAINMENT":
      return <span className="Linkedin-Reaction__Label" style={{ color: "rgb(20, 111, 126)" }}><Trans>Funny</Trans></span>;
    default:
      return <Trans>Like</Trans>;
  }
};

export default LinkedinReactionText;
